import { Injectable } from "@angular/core";

import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { catchError } from "rxjs/operators";

import { environment } from "../environments/environment";

import { BaseService } from "./base.service";

import { Helpers } from "../helpers/helpers";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { RequestModel } from "./reports/careplus-report.service";

@Injectable({
  providedIn: "root",
})
export class ReportService extends BaseService {
  protected pathAPI = environment.apiUrl;

  public errorMessage: string;

  constructor(
    protected http: HttpClient,
    helper: Helpers,
    protected snackBar: MatSnackBar,
  ) {
    super(helper);
  }

  downloadReport(reportName: string, body: any) {
    const headers = super.header().headers;
    return this.http
      .post(this.pathAPI + "reports/" + reportName, body, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }
  downloadSafrattiReport(reportName: string, body: any) {
    const headers = super.header().headers;
    return this.http
      .post(this.pathAPI + "Reports/" + reportName, body, {
        headers,
        observe: "response",
        responseType: "blob",
      })
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downloadCarePlusReport(body: RequestModel, isOrder: boolean) {
    const headers = super.header().headers;
    return this.http
      .post(
        this.pathAPI +
          `reports/downloadCarePlusRequestsByDayReport?isOrder=${isOrder}`,
        body,
        {
          headers,
          observe: "response",
          responseType: "blob",
        },
      )
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downloadAgencyHRReport(body: any, isXls: boolean) {
    const headers = super.header().headers;

    return this.http
      .post(
        this.pathAPI +
          `Reports/DownloadCarePlusHrAgencyOrdersReport?isXls=${isXls}`,
        body,
        {
          headers,
          observe: "response",
          responseType: "blob",
        },
      )
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downloadAgencyHREmployeesReport(body: any, isXls: boolean) {
    const headers = super.header().headers;

    return this.http
      .post(
        this.pathAPI +
          `Reports/DownloadCarePlusHRAgencyEmployeesReport?isXls=${isXls}`,
        body,
        {
          headers,
          observe: "response",
          responseType: "blob",
        },
      )
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downloadAgencyHRSubmittedFormsReport(body: any, isXls: boolean) {
    const headers = super.header().headers;

    return this.http
      .post(
        this.pathAPI +
          `Reports/DownloadCarePlusHRAgencyFormsubmittedReport?isXls=${isXls}`,
        body,
        {
          headers,

          observe: "response",
          responseType: "blob",
        },
      )
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downloadCareplusPromotionUsercode(couponCode: string) {
    const headers = super.header().headers;
    return this.http
      .post(
        this.pathAPI +
          `Reports/DownloadCarePlusPromotionUsercodeReport?CouponCode=${couponCode}`,
        {},
        {
          headers,
          observe: "response",
          responseType: "blob",
        },
      )
      .pipe(catchError(super.handleError))
      .subscribe(
        (response) => {
          this.downLoadFile(response);
        },
        (err) => {
          this.snackBar.open(err, "CANCEL", {
            horizontalPosition: "right",
            duration: 2000,
          });
        },
      );
  }

  downLoadFile(response: any) {
    const contentType: string = response.headers.get("Content-Type");
    const contentDisposition = response.headers.get("Content-Disposition");

    let fileName = "report";
    if (contentDisposition) {
      try {
        fileName = contentDisposition
          .split(";")[1]
          .split("filename")[1]
          .split("=")[1]
          .trim();
      } catch (e) {
        console.warn(
          "Could not parse filename from Content-Disposition header:",
          contentDisposition,
        );
      }
    }

    const blob = new Blob([response.body], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.download = fileName;
    anchor.href = url;
    anchor.click();
  }
}
